import { EChartsOption } from "echarts"

const config: EChartsOption = {
  amap: {
    roam: true,
    center: [116.397428, 39.90923],
    zoom: 10,
    viewMode: "2D",
    mapStyle: "amap://styles/normal",
  },
  series: [],
}

export default config
